import { schema } from "normalizr";

const polsterSchema = new schema.Entity("polster", {}, { idAttribute: "id" });

export { polsterSchema };
